'use client';

import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import { type Analytics, getAnalyticsInstance } from '~/lib/atom/analytics';
import { PriceConfig } from '~/lib/atom/types/price-config';

const AnalyticsContext = createContext<Analytics | null>(null);

interface Props {
  priceConfig: PriceConfig;
}

export const AnalyticsProvider = ({ children, priceConfig }: PropsWithChildren<Props>) => {
  const analytics = useMemo(() => {
    return getAnalyticsInstance({ priceConfig });
    // this is risky if we need to add any additional values to price config but currencies were
    // causing re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    priceConfig.countryCode,
    priceConfig.currencyCode,
    priceConfig.priceListId,
    priceConfig.searchLookupPriceListId,
  ]);

  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
};

export const useAnalyticsContext = () => {
  const context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error('useAnalyticsContext must be used within a AnalyticsProvider');
  }

  return context;
};
